export var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus[RsvpStatus["YES"] = 0] = "YES";
    RsvpStatus[RsvpStatus["NO"] = 1] = "NO";
    RsvpStatus[RsvpStatus["WAITING"] = 2] = "WAITING";
})(RsvpStatus || (RsvpStatus = {}));
export var RsvpTag;
(function (RsvpTag) {
    RsvpTag[RsvpTag["FULLY_CHECKED_IN"] = 0] = "FULLY_CHECKED_IN";
    RsvpTag[RsvpTag["NOT_FULLY_CHECKED_IN"] = 1] = "NOT_FULLY_CHECKED_IN";
    RsvpTag[RsvpTag["MEMBER"] = 2] = "MEMBER";
})(RsvpTag || (RsvpTag = {}));
export var RsvpFieldset;
(function (RsvpFieldset) {
    RsvpFieldset[RsvpFieldset["DETAILS"] = 0] = "DETAILS";
    RsvpFieldset[RsvpFieldset["FORM"] = 1] = "FORM";
    RsvpFieldset[RsvpFieldset["CONTACT_DETAILS"] = 2] = "CONTACT_DETAILS";
})(RsvpFieldset || (RsvpFieldset = {}));
//# sourceMappingURL=rsvp.js.map